/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_SubtitleInputs */

const en_visa_eb2niw_subtitle = /** @type {(inputs: Visa_Eb2niw_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NATIONAL INTEREST WAIVER`)
};

const pt_visa_eb2niw_subtitle = /** @type {(inputs: Visa_Eb2niw_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DISPENSA DE INTERESSE NACIONAL`)
};

const es_visa_eb2niw_subtitle = /** @type {(inputs: Visa_Eb2niw_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXENCIÓN POR INTERÉS NACIONAL`)
};

/**
* | output |
* | --- |
* | "NATIONAL INTEREST WAIVER" |
*
* @param {Visa_Eb2niw_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_subtitle = /** @type {((inputs?: Visa_Eb2niw_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_subtitle(inputs)
	if (locale === "es") return es_visa_eb2niw_subtitle(inputs)
	return en_visa_eb2niw_subtitle(inputs)
});